module.exports = __webpack_public_path__ + "da09dcc0cddbcf750c1c554a60f07c69.jpg";